module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createSpreadsheet":"Create spreadsheet","updateSpreadsheet":"Update spreadsheet","spreadsheet":"Laptops spreadsheet"}}')
  delete Component.options._Ctor
}
